import {
  search_styles_default
} from "./chunk.QZ2CXLRR.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/search/search.ts
import { t as t2 } from "i18next";
var FadvSearch = class extends s {
  constructor() {
    super(...arguments);
    this.size = "small";
    this.label = t2("components:search.label");
    this.mode = "expanded";
    this.focused = false;
    this.hasValue = false;
  }
  get isCollapsed() {
    if (this.mode !== "collapsed")
      return false;
    return !this.focused && !this.hasValue;
  }
  emitSubmission() {
    if (this.autoclear) {
      this.reset();
    }
    emit(this, "fadv-search-submitted", { detail: { query: this.input.value } });
  }
  handleSubmit(event) {
    this.emitSubmission();
    event.stopPropagation();
    event.preventDefault();
  }
  handleClick() {
    if (this.isCollapsed) {
      requestAnimationFrame(() => this.input.focus());
    } else {
      this.emitSubmission();
    }
  }
  handleKeyDown(event) {
    if (event.key === "Enter") {
      this.emitSubmission();
    }
  }
  handleClear() {
    this.reset();
    this.emitSubmission();
  }
  handleFocus() {
    this.focused = true;
    emit(this, "sl-focus");
  }
  handleBlur() {
    this.focused = false;
    emit(this, "sl-blur");
  }
  handleInput(event) {
    this.hasValue = !!this.input.value;
    event.stopPropagation();
    emit(this, "fadv-search-input", { detail: { query: this.input.value } });
  }
  reset() {
    this.input.value = "";
    this.hasValue = false;
    this.input.blur();
  }
  blur() {
    this.input.blur();
  }
  focus(options) {
    this.input.focus(options);
  }
  render() {
    return $`<form role="search" class=${o({
      search: true,
      "search--small": this.size === "small",
      "search--medium": this.size === "medium",
      "search--large": this.size === "large",
      "search--focused": this.focused,
      "search--has-value": this.hasValue,
      "search--collapsed": this.isCollapsed
    })} @submit=${this.handleSubmit} ><div class="search__interior"><input size="1" id="search-input" class="search__input" @keydown=${this.handleKeyDown} @input=${this.handleInput} @focus=${this.handleFocus} @blur=${this.handleBlur} minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} required /><button aria-label=${t2("components:common.clearEntry")} part="clear-button" class="search__clear" type="button" tabindex="-1" @click=${this.handleClear} ><fadv-icon name="circle-xmark" library="solid"></fadv-icon></button><sl-icon-button @click=${this.handleClick} class="search__button" name="fa-magnifying-glass" library="solid" label=${t2("components:search.label")} ></sl-icon-button></div><label for="search-input" class="search__label">${this.label}</label></form>`;
  }
};
FadvSearch.styles = search_styles_default;
__decorateClass([
  e()
], FadvSearch.prototype, "size", 2);
__decorateClass([
  e({ type: Number })
], FadvSearch.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], FadvSearch.prototype, "maxlength", 2);
__decorateClass([
  e()
], FadvSearch.prototype, "label", 2);
__decorateClass([
  e()
], FadvSearch.prototype, "mode", 2);
__decorateClass([
  e({ type: Boolean })
], FadvSearch.prototype, "autoclear", 2);
__decorateClass([
  i(".search__input")
], FadvSearch.prototype, "input", 2);
__decorateClass([
  t()
], FadvSearch.prototype, "focused", 2);
__decorateClass([
  t()
], FadvSearch.prototype, "hasValue", 2);
FadvSearch = __decorateClass([
  n("fadv-search")
], FadvSearch);

export {
  FadvSearch
};
